import {Api} from "@/common/ajax/Api";
import { useBookmarksStore } from '../../pinia/stores/bookmarks'
import { isAxiosNetworkError, reportAxiosNetworkError } from '@features/_common/errorHandler'



export const getMarkedQuestionsCount    = () => useBookmarksStore().markedQuestionsCount
export const setMarkedQuestionsCountTo  = (count) => useBookmarksStore().setMarkedQuestionsCountTo(count)
export const incMarkedQuestionsCount    = () => useBookmarksStore().incMarkedQuestionsCount()
export const decMarkedQuestionsCount    = () => useBookmarksStore().decMarkedQuestionsCount()

export const getRemoteMarkedQuestionsCount = (professionID) =>
    Api.getBookmarksCountFor(professionID).catch((err) => {
        if (isAxiosNetworkError(err)) {
            reportAxiosNetworkError(err, 'bookmarks.count', { professionID })
        }
        return { data: 0 }
    })